'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('gestionBudgets', function () {
  return {
    restrict: 'E',
    scope: true,
    template: require('./gestionBudgets.html'),
    controller: 'GestionBudgetsController'
  };
});
ngModule.controller('GestionBudgetsController', function ($scope, $q, $http, $modal, $compile, $session, budgetService, contextService, $dialogBox) {
  var reloadContext = function reloadContext() {
    contextService.refreshData();
  };
  var loadBudgets = function loadBudgets() {
    return $q.when(budgetService.findAll({
      showArchive: true,
      showAllModules: true
    })).then(function (budgets) {
      $scope.budgets = budgets;
    });
  };
  loadBudgets();
  function refreshBudgetService() {
    budgetService.$reload();
  }
  $scope.$on("$destroy", function () {
    refreshBudgetService();
  });

  //// comptes liées
  var compte = $session.getCompte();
  $scope.comptesLies = [{
    "id": compte.id,
    "nom": compte.nomClient
  }];
  _.each(compte.comptesLies, function (nom, id) {
    $scope.comptesLies.push({
      "id": id,
      "nom": nom
    });
  });
  $scope.aComptesLies = $session.possedeComptesLies();
  $scope.compteLie = function (compteId) {
    return _.find($scope.comptesLies, function (e) {
      return e.id === compteId;
    }).nom;
  };
  ////

  var creationPopinModalOptions = {
    controller: "SaisieBudgetCreationPopinController",
    template: require("./budgetCreationPopin.html"),
    options: {
      width: 800
    }
  };
  var deplacementPopinModalOptions = {
    controller: "SaisieBudgetDeplacementPopinController",
    template: require("./budgetDeplacementPopin.html"),
    options: {
      width: 800
    }
  };
  $scope.openCreationPopin = function (parentBudget) {
    return $modal.open(_.extend(creationPopinModalOptions, {
      vars: {
        parent: parentBudget
      }
    }));
  };
  $scope.openEditionPopin = function (budget) {
    return $modal.open(_.extend(creationPopinModalOptions, {
      vars: {
        edition: true,
        budget: budget
      }
    }));
  };
  $scope.openDeplacementPopin = function (budget) {
    return $modal.open(_.extend(deplacementPopinModalOptions, {
      vars: {
        budget: budget
      }
    }));
  };

  // context menu

  var openedContextMenu = null;
  var contextMenuRow = null;
  var contextMenuLink = $compile("<saisie-budget-context-menu></saisie-budget-context-menu>");
  $scope.showBudgetContextMenu = function (budget, event) {
    $scope.hideBudgetContextMenu();
    var row = $(event.currentTarget);
    if (row.is(contextMenuRow)) {
      contextMenuRow = null;
      return;
    }
    contextMenuRow = row;
    var contextMenuScope = $scope.$new();
    _.extend(contextMenuScope, {
      budget: budget
    });
    contextMenuLink(contextMenuScope, function (contextMenu) {
      openedContextMenu = contextMenu;
      contextMenu.appendTo(row);
    });
  };
  $scope.hideBudgetContextMenu = function () {
    if (openedContextMenu == null) {
      return;
    }
    openedContextMenu.scope().$destroy();
    openedContextMenu.remove();
    openedContextMenu = null;
  };

  // end context menu

  var getTreeTableConfig = function getTreeTableConfig() {
    return {
      source: "budgets",
      labelAttribute: "nom",
      childrenAttribute: "children",
      mainCellContentTemplate: '' + '<div class="budget" ng-click="showBudgetContextMenu(model, $event)">' + '   <i class="fa {{depth == 0 ? \'fa-book\' : \'fa-file-text\'}}"></i>' + '<i class="fa fa-parking-circle blue principal" tl-tooltip="Budget principal" ng-if="model.type===\'PRINCIPAL\'"></i>' + '   <span style="text-decoration : underline {{model.color||\'undefined\'}} 3px">{{model.nom}}' + '<span ng-if="model.planComptable"> ({{"lov.plansComptables."+model.planComptable|translate}})</span></span>' + '<span ng-if="model.archive" class="b i"> (Archivé)</span>' + '<span ng-if="model.moduleSubvention && model.compteBudgetAvecModuleDette" class="module-pill capitalise-pill ml-xs" tl-tooltip="Budget disponible dans le module Subvention">S</span>' + '<span ng-if="model.moduleDette && model.compteBudgetAvecModuleSubvention" class="module-pill sim-pill ml-xs" tl-tooltip="Budget disponible dans le module Dette">D</span>' + '   <span class="ml-xs" ng-if="aComptesLies">({{compteLie(model.compteId)}})</span>' + '</div>'
    };
  };
  $scope.treeTableConfig = getTreeTableConfig();
  $scope.addBudget = function () {
    return $scope.openCreationPopin().then(function (newBudget) {
      $scope.budgets.push(newBudget);
      refreshBudgetService();
    });
  };
  $scope.addChildBudget = function (parentBudget) {
    return $scope.openCreationPopin(parentBudget).then(function (newBudget) {
      parentBudget.children.push(newBudget);
      refreshBudgetService();
    });
  };
  $scope.editBudget = function (budget) {
    return $scope.openEditionPopin(budget).then(function (editedBudget) {
      _.extend(budget, editedBudget);
      refreshBudgetService();
    });
  };
  $scope.deplaceBudget = function (budget) {
    return $scope.openDeplacementPopin(budget).then(function (movedBudget) {
      removeBudget(budget);

      // trouve le nouveau budget parent et ajoute ce budget
      if (movedBudget.parentId == null) {
        $scope.budgets.push(movedBudget);
      } else {
        var newParentBudget = findBudget($scope.budgets, movedBudget.parentId);
        newParentBudget.children.push(movedBudget);
      }
      refreshBudgetService();
    });
  };
  function removeBudget(budget) {
    var budgetIdx;
    if (budget.parentId) {
      var parentBudget = findParentBudget($scope.budgets, budget.id);
      budgetIdx = _.indexOf(parentBudget.children, budget);
      parentBudget.children.splice(budgetIdx, 1);
    } else {
      budgetIdx = _.indexOf($scope.budgets, budget);
      $scope.budgets.splice(budgetIdx, 1);
    }
  }
  $scope.deleteBudget = function (budget) {
    $http.post("/rest/budgets/" + budget.id + "/delete", budget).then(function (response) {
      var data = response.data;
      if (data === null || data.length === 0) {
        removeBudget(budget);
        refreshBudgetService();
        reloadContext();
      } else {
        var max = 8;
        var msg = "";
        var items;
        if (data.length > max) {
          items = data.slice(0, max);
        } else {
          items = data;
        }
        _.each(items, function (item) {
          msg += '<p>' + item.response + '</p>';
        });
        if (data.length > max) {
          msg += '<p class="i mt-s">' + 'et ' + (data.length - max) + ' autres erreurs...' + '</p>';
        }
        $dialogBox.alert({
          title: "Impossible de supprimer ce budget",
          html: msg
        });
      }
    });
  };
  var findParentBudget = function findParentBudget(budgetList, budgetId) {
    var budget;
    var _recurseFind = function recurseFind(children, parentBudget) {
      for (var i = 0; i < children.length; i++) {
        budget = children[i];
        if (budget.id === budgetId) {
          return parentBudget;
        } else if (budget.children.length) {
          budget = _recurseFind(budget.children, budget);
          if (budget) {
            return budget;
          }
        }
      }
      return null;
    };
    return _recurseFind(budgetList, null);
  };
  var findBudget = function findBudget(budgetList, budgetId) {
    var budget;
    var _recurseFind2 = function recurseFind(children, parentBudget) {
      for (var i = 0; i < children.length; i++) {
        budget = children[i];
        if (budget.id === budgetId) {
          return budget;
        } else if (budget.children.length) {
          budget = _recurseFind2(budget.children, budget);
          if (budget) {
            return budget;
          }
        }
      }
      return null;
    };
    return _recurseFind2(budgetList, null);
  };
});
ngModule.directive("saisieBudgetContextMenu", function ($dialogBox, $translate) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<div class="budget-context-menu">' + '<i ng-click="onEditClick()" class="fa fa-edit" title="Editer le budget"></i>' + '<i ng-click="onAddClick()" class="fa fa-plus-square" title="Ajouter un sous-budget"></i>' + '<i authz-if-intra ng-click="onDeplaceClick()" class="fa fa-arrow-right" title="Deplacer ce budget"></i>' + '<i ng-if="!budget.children.length" ng-click="onDeleteClick()" class="fa fa-times-circle" title="Supprimer ce budget"></i>' + '</div>',
    link: function link($scope, $el, $attrs) {
      var budget = $scope.budget;
      $el.click(function (event) {
        event.stopPropagation();
      });
      $scope.onEditClick = function () {
        $scope.hideBudgetContextMenu();
        $scope.editBudget(budget);
      };
      $scope.onAddClick = function () {
        $scope.hideBudgetContextMenu();
        $scope.addChildBudget(budget);
      };
      $scope.onDeplaceClick = function () {
        $scope.hideBudgetContextMenu();
        $scope.deplaceBudget(budget);
      };
      $scope.onDeleteClick = function () {
        $scope.hideBudgetContextMenu();
        $dialogBox.confirm({
          title: $translate("saisie.budget.popins.delete.title"),
          text: $translate("saisie.budget.popins.delete.text", {
            budget: budget.nom
          })
        }).then(function () {
          $scope.deleteBudget(budget);
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/budget/gestionBudgets/gestionBudgets.js
// module id = 2682
// module chunks = 13